<template>
  <div class="plans">
    <va-card :title="$t('plans.title')">
      <template slot="actions">
        <va-button :to="{ name: 'plan-add' }" icon="fa fa-plus"/>
      </template>
      <va-data-table
        :fields="fields"
        :data="plans"
        :per-page="perPage"
        :totalPages="totalPages"
        :loading="loading"
        @page-selected="showMore"
        no-data-label="Sem Dados Cadastrados"
        api-mode
      >
        <template slot="actions" slot-scope="props">
          <va-popover :message="`${$t('plans.tooltips.update')}`" placement="bottom">
            <va-button
              flat
              color="gray"
              icon="fa fa-pencil"
              :to="{ name: 'plan-update', params: { planId: props.rowData.id } }"
            />
          </va-popover>
          <va-popover :message="`${$t('tooltips.delete')}`" placement="bottom">
            <va-button
              flat
              color="gray"
              icon="fa fa-trash"
              @click="showModal(props.rowData.id)"
            />
          </va-popover>
        </template>
      </va-data-table>
    </va-card>
    <va-modal
      v-model="modalDeletar"
      size="small"
      :title="$t('modals.titleDelete')"
      :message="$t('plans.modals.message')"
      :okText="$t('modals.confirm') "
      :cancelText="$t('modals.cancel')"
      @ok="deleting"
    />
  </div>
</template>

<script>
import gql from 'graphql-tag'

const perPage = 10
export default {
  name: 'plans',
  components: {},
  methods: {
    showModal (id) {
      this.modalDeletar = true
      this.deleteId = id
    },
    showMore (page) {
      this.loading = true
      this.page = page
      this.$apollo.queries.plans.fetchMore({
        variables: {
          page: (page - 1) * this.perPage,
          perPage: this.perPage,
        },
        updateQuery: (_, { fetchMoreResult }) => {
          this.loading = false
          return fetchMoreResult
        },
      })
    },
    deleting () {
      this.$apollo
        .mutate({
          mutation: gql`
            mutation MyMutation($id: Int!) {
              delete_plan_by_pk(id: $id) {
                id
              }
            }
          `,
          variables: {
            id: this.deleteId,
          },
        })
        .then(data => {
          this.$apollo.queries.pages.refetch()
          this.showMore(this.page)
          this.showToast(
            this.$t('toasts.successDelete'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
        .catch(_ => {
          this.showToast(
            this.$t('toasts.errorDelete'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
    },
  },
  data () {
    return {
      plans: [],
      page: 1,
      perPage: perPage,
      pages: null,
      loading: false,
      modalDeletar: false,
      deleteId: 0,
    }
  },
  apollo: {
    plans: {
      query: gql`
      query MyQuery($page: Int = 0, $perPage: Int = 2) {
        plans: plan(limit: $perPage, offset: $page, order_by: {id: asc}) {
          amount
          duration
          id
          name
        }
      }
      `,
      variables: {
        perPage,
        page: 0,
      },
    },
    pages: gql`
    query MyQuery {
      pages: plan_aggregate {
        aggregate {
          count
        }
      }
    }
    `,
  },
  computed: {
    totalPages () {
      return this.pages != null ? Math.ceil(this.pages.aggregate.count / this.perPage) : 0
    },
    fields () {
      return [{
        name: 'id',
        title: this.$t('tables.id'),
        width: '50px',
      }, {
        name: 'name',
        title: this.$t('plans.headings.name'),
        width: '40%',
      }, {
        name: 'amount',
        title: this.$t('plans.headings.amount'),
        width: '20%',
        callback (value) {
          return 'R$' + value
        },
      }, {
        name: 'duration',
        title: this.$t('plans.headings.duration'),
        width: '20%',
      }, {
        name: '__slot:actions',
        title: this.$t('tables.actions'),
        dataClass: 'text-center',
      }]
    },
  },
  mounted () {
    if (Object.keys(this.$apollo.queries).includes('plans')) {
      this.$apollo.queries.pages.refetch()
      this.$apollo.queries.plans.refetch()
    }
  },
}
</script>

<style lang="scss">
</style>
